module.exports = __webpack_public_path__ + "static/img/02hao.00131e17.gif";